export class CaseDocs extends HTMLElement
{
    constructor()
    {
        super();
    }

    connectedCallback()
    {
        this.init();
        this._boundOnPopState = this.onPopState.bind(this);
        window.addEventListener('popstate', this._boundOnPopState);
    }

    disconnectedCallback()
    {
        window.removeEventListener('popstate', this._boundOnPopState);
    }

    init()
    {
        this.initEventListeners();
    }

    initEventListeners()
    {
        const deleteFiles = this.querySelectorAll('.delete-file');
        deleteFiles.forEach((elem) => {
            elem.addEventListener('click', (event) => {
                this.deleteFileClick(event);
            });
        });

        const restoreFiles = this.querySelectorAll('.restore-file');
        restoreFiles.forEach((elem) => {
            elem.addEventListener('click', (event) => {
                this.restoreFileClick(event);
            });
        });
    }

    deleteFileClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const target = event.target;
        const targetRow = target.closest('tr');
        if (!targetRow) {
            console.error('Target row not found');
            return;
        }

        // send delete file msg to server
        const formData = new FormData();
        formData.append('caseDocID', targetRow.dataset.file_id);
        formData.append('_token', this.dataset.token);

        toastr.info('Deleting file', null);

        fetch('/api/case-doc-delete', {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json'
            }

        }).then((response) => {
            toastr.clear();
            if (response.ok) {
                response.json().then(data => {
                    if (data.success) {
                        toastr.success('File deleted successfully');
                        targetRow.classList.add('deleted');
                        const deleteLink = targetRow.querySelector('.doc-link');
                        if (deleteLink) {
                            deleteLink.classList.add('disabled');
                        }
                        if (data.removed_when) {
                            targetRow.querySelector('.doc-deleted').innerHTML = "On " + data.removed_when;
                        }
                    } else {
                        toastr.error(data.error);
                    }
                });
            } else {
                toastr.error('You do not have permission to delete this file');
                console.error("You do not have permission to delete this file");
            }
        }).catch((error) => {
            toastr.error('There was a problem with the fetch operation:');
            console.error('There was a problem with the fetch operation:');
        });
    }

    restoreFileClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const target = event.target;
        const targetRow = target.closest('tr');
        if (!targetRow) {
            console.error('Target row not found');
            return;
        }

        // send restore file msg to server
        const formData = new FormData();
        formData.append('caseDocID', targetRow.dataset.file_id);
        formData.append('_token', this.dataset.token);

        toastr.info('Restoring file', null);
        fetch('/api/case-doc-restore', {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json'
            }

        }).then((response) => {
            if (response.ok) {
                response.json().then(data => {
                    if (data.success) {
                        toastr.clear();
                        toastr.success('File restored successfully');
                        targetRow.classList.remove('deleted');
                        const deleteLink = targetRow.querySelector('.doc-link');
                        if (deleteLink) {
                            deleteLink.classList.remove('disabled');
                        }
                    } else {
                        toastr.clear();
                        toastr.error(data.error);
                    }
                });
            } else {
                toastr.error('You do not have permission to restore this file');
                console.error("You do not have permission to restore this file", response.statusText);
            }
        }).catch((error) => {
            toastr.error('There was a problem with the fetch operation:');
            console.error('There was a problem with the fetch operation:');
        });
    }

    onPopState(event) {
        event.stopImmediatePropagation();
        const backBtn = this.querySelector('.closeLevel');
        if (backBtn) {
            backBtn.click();
        }
    }
}

customElements.define('case-docs', CaseDocs);